import { type FilterValues } from "components/filters/FilterContext";
import { mapResponseToAddressFilter, mapAddressFilterToInstruction, mapResponseToFinancialRiskFilter, mapFinancialRiskFilterToInstruction, mapResponseToKeywordFilter, mapKeywordFilterToInstruction, mapResponseToTagFilter, mapTagFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.ListPromoterInstruction => ({
  keyword: mapKeywordFilterToInstruction(filter.keyword),
  address: mapAddressFilterToInstruction(filter.address),
  financialRisks: mapFinancialRiskFilterToInstruction(filter.financialRisks),
  tags: mapTagFilterToInstruction(filter.tags),
  page,
  perPage,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.ListPromoterFilters,
  values: FilterValues
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
  address: mapResponseToAddressFilter(response.address),
  financialRisks: mapResponseToFinancialRiskFilter(response.financialRisks),
  tags: mapResponseToTagFilter(response.tags, values.tags)
});
